export { default as ListInductees } from './ListInductees';